import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { toaster } from '@enechain/ecloud-designsystem'

import { updateOwnMemberProfile } from '~/gen/proto/bff/v1/common-BffCommonService_connectquery'
import { BffCommonService } from '~/gen/proto/bff/v1/common_pb'

export function useProfileMutation(): ReturnType<typeof useMutation> {
  const queryClient = useQueryClient()
  return useMutation(updateOwnMemberProfile, {
    onError: (error) => {
      toaster.create({
        title: error.message,
        type: 'error',
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: BffCommonService.method.getMemberProfile,
          cardinality: 'finite',
        }),
      })
    },
  })
}
